import { useAppSelector } from '~/hooks';

export const useGetUnavailableDates = (jobPostingId: string | undefined) => {
  const interviews = useAppSelector((state) => {
    if (!jobPostingId) {
      return [];
    }

    return state.permanentJobs.onsiteInterviews[jobPostingId] || [];
  });

  return interviews.map((it) => new Date(it.date));
};
